<template>
  <div :class="`${LayoutType} ${Theme}`">
    <!-- ---------------------------------- -->
    <!--- Vertical Header part  Plantilla nombre Monitoreo-->
    <!-- ---------------------------------- -->
    <VerticalSidebar v-if="!setHorizontalLayout" />
    <aside
      :class="
        setHorizontalLayout == true ? 'horizontal-page-wrapper' : 'page-wrapper'
      "
    >
      <VerticalHeader v-if="!setHorizontalLayout" />
      <HorizontalHeader v-if="setHorizontalLayout" />
      <HorizontalSidebar v-if="setHorizontalLayout" />
      <div
        class="min-height"
        :class="
          setHorizontalLayout == true
            ? 'container-fluid content-wrapper'
            : 'container-fluid content-wrapper'
        "
      >
        <h3 class="mb-2 ml-3 estilo" v-if="$route.path !== '/starter'">
          {{ this.$t(`${$route.name}`) }}
        </h3>
        <router-view />
      </div>
      <Footer />
    </aside>
  </div>
</template>

<script>
import VerticalHeader from "./vertical-header/VerticalHeader";
import HorizontalHeader from "./horizontal-header/HorizontalHeader";
import HorizontalSidebar from "./horizontal-sidebar/HorizontalSidebar";
import VerticalSidebar from "./vertical-sidebar/VerticalSidebar";
import Footer from "./footer/Footer";
import { mapState } from "vuex";
export default {
  name: "FullLayout",
  components: {
    VerticalHeader,
    VerticalSidebar,
    HorizontalSidebar,
    HorizontalHeader,
    Footer,
  },
  data: () => ({
    // cpath: this.currentRoute.path,
    items: [
      {
        text: "Dashboard",
        href: "/",
      },
      {
        text: "",
        active: true,
      },
    ],
  }),
  computed: {
    ...mapState(["LayoutType", "Theme", "setHorizontalLayout"]),
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    //define below method first.
    winWidth: function () {
      setInterval(() => {
        let w = window.innerWidth;
        this.$store.commit("SET_LAYOUT_TYPE", "mini-sidebar");
        if (w < 992) {
          this.$store.commit("SET_LAYOUT_TYPE", "mini-sidebar");
        }
      }, 100);
    },
  },
  mounted() {
    //callback once mounted
    this.winWidth();
  },
  watch: {},
};
</script>

<style>
.estilo{
  font-size: 25px;
  color: #002060;
  font-weight: 520;
  padding-bottom: 0%;
}
.content-wrapper{
  margin-right:0%; 
  margin-left:  0%; 
  max-width: 100%; 
  padding-right: 30px; 
  padding-left:  30px;
}

@media (max-width: 600px) {
  .estilo {
    font-size: 19px !important;
  }
}

@media (max-width: 991.98px)  and (max-height: 950px){
  .content-wrapper{
  margin-right:0%; 
  margin-left:  0%; 
  max-width: 100%; 
  padding-right: 5%; 
  padding-left:  5%;
  }
  .estilo{
  font-size: 25px;
  color: #002060;
  font-weight: 520;
  text-align: center;
  padding-top: 2%;
  padding-bottom: 0%;
  }
}
</style>